module.exports = __webpack_public_path__ + "img/activity6.433a5c9a.png";